module.exports = __webpack_public_path__ + "static/about-three-small-f18eece4e1e6fe2b7ba0c840e9b7c735.webp";